export default function createSharedNameString(names = []) {
  let shareWithNames = "";

  const sharableWith = names.filter((name) => name.length > 0);
  const emptyNameCount = names.length - sharableWith.length;

  if (sharableWith.length === 0 && emptyNameCount === 1)
    return "your household";

  //sharableWith.sort((name) => (name.length > 0 ? -1 : 0));

  sharableWith.forEach((name, index) => {
    if (index > 0) {
      if (sharableWith.length === 2) shareWithNames += " & ";
      else {
        shareWithNames += ", ";
        if (index === sharableWith.length - 1) shareWithNames += "and ";
      }
    }
    shareWithNames += name;
  });

  if (emptyNameCount > 0) {
    if (sharableWith.length > 0) {
      if (sharableWith.length > 1) shareWithNames += ",";
      shareWithNames += " and ";
    }

    shareWithNames +=
      emptyNameCount +
      (sharableWith.length > 0 ? " other " : " ") +
      (emptyNameCount === 1 ? "person" : "people") +
      " in your household.";
  }

  return shareWithNames;
}
